import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { useIntl } from '@divvy-web/i18n'
import BasicButton, { BASIC_BUTTON_COLOR_NEUTRAL, BASIC_BUTTON_TYPE_FLAT } from '@divvy-web/skylab.basicbutton'

import { LogoutButton } from '@sputnik/components'
import BillBrandLogo from '@sputnik/components/BillBrandLogo'
import { URL } from '@sputnik/resources/constants'

import styles from './styles.module.scss'

const DashboardHeader = () => {
  const [getClassName] = useNameFormatter('DashboardHeader')
  const { formatMessage } = useIntl()

  const onHelpClick = () => {
    window.open(URL.BILL_HELP_CENTER_LINK, '_blank', 'noopener, noreferrer')
  }

  return (
    <div className={styles[getClassName('')]}>
      <BillBrandLogo />
      <div className={styles[getClassName('actions')]}>
        <div className={styles[getClassName('help-icon')]}>
          <BasicButton
            color={BASIC_BUTTON_COLOR_NEUTRAL}
            icon='help'
            name={formatMessage({ defaultMessage: 'open bill help site', id: 'sputnik.DashboardHeader__CLAjD/' })}
            type={BASIC_BUTTON_TYPE_FLAT}
            onClick={onHelpClick}
          />
        </div>
        <LogoutButton color={BASIC_BUTTON_COLOR_NEUTRAL} />
      </div>
    </div>
  )
}

export default DashboardHeader
